import {
  GET_EXCO_KABKOT,
  GET_EXCO_KABKOT_SUCCESS,
  GET_EXCO_KABKOT_FAIL,
} from "./actionTypes";

const initialState = {
  dataKabKot: {
    loading: false,
    error: false,
    data: null,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EXCO_KABKOT:
      return {
        ...state,
        dataKabKot: {
          ...state.dataKabKot,
          loading: true,
          error: false,
          isLoggedIn: false,
        },
      };
    case GET_EXCO_KABKOT_SUCCESS:
      return {
        ...state,
        dataKabKot: {
          ...state.dataKabKot,
          loading: false,
          error: false,
          isLoggedIn: true,
          data: action.payload,
        },
      };
    case GET_EXCO_KABKOT_FAIL:
      return {
        ...state,
        dataKabKot: {
          ...state.dataKabKot,
          loading: false,
          error: action.payload,
          isLoggedIn: false,
        },
      };
    default:
      return state;
  }
};

export default reducer;
